import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { BitfFile } from '@bitf/core/models/bitf-file.model';
import { BitfFileUploaderComponent } from '@common/libs/bitforce/core/components/ui/file-uploader/bitf-file-uploader.component';
import { Image } from '@common/core/models';

export type SelectedImage = Image | BitfFile;

export interface ImagesSelection {
  presetImages: Image[];
  files: BitfFile[];
}

@Component({
  selector: 'mpa-file-uploader-tiles',
  templateUrl: './file-uploader-tiles.component.html',
  styleUrls: ['./file-uploader-tiles.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FileUploaderTilesComponent extends BitfFileUploaderComponent<BitfFile> implements OnInit {
  @Output() imagesChanged = new EventEmitter<ImagesSelection>();

  // Images set from other components (preset images)
  @Input() presetImages: Image[] = [];

  @Input() indexFrom: number | null = 0;

  get tiles(): any[] {
    return [...this.presetImages, ...this.files];
  }

  constructor(public injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  // NOTE: ordered selection, preset medias first then personal uploads
  get selectedImages(): ImagesSelection {
    return { presetImages: this.presetImages, files: this.files };
  }

  onFileDropped(event: FileList | any): void {
    super.onFileDropped(event);
    this.emitImagesChanged();
  }

  removePresetImage(index: number): void {
    this.presetImages.splice(index, 1);
    this.emitImagesChanged();
  }

  removeFile(index: number): void {
    super.removeFile(index);
    this.emitImagesChanged();
  }

  // tiles merges presetImages and files: the incoming index refers to the merged list
  removeTile(index: number): void {
    if (index < this.presetImages.length) {
      this.removePresetImage(index);
    } else {
      this.removeFile(index - this.presetImages.length);
    }
  }

  getImageUrl(file: BitfFile): string {
    if (file.isImage && file.fileObject) {
      return URL.createObjectURL(file.fileObject);
    }
    return '';
  }

  getPresetImageUrl(image: Image): string {
    return image?.getImageByFormat('xsmall')?.url;
  }

  private emitImagesChanged(): void {
    this.imagesChanged.emit(this.selectedImages);
  }
}
